import { createAction } from "@reduxjs/toolkit";
import { ActionsEnum } from '../../enums/actions.enum';

export const POPUP_SLICE = 'Popup';

export const setErrorMessage = createAction<string>(ActionsEnum.SET_ERROR_MESSAGE);
export const removeErrorMessage = createAction(ActionsEnum.REMOVE_ERROR_MESSAGE);
export const setSuccessMessage = createAction<string>(ActionsEnum.SET_SUCCESS_MESSAGE);
export const removeSuccessMessage = createAction(ActionsEnum.REMOVE_SUCCESS_MESSAGE);
